<template>
  <div :data-upd="selected">
    <div class="filter-list__item-label" v-show="!filter.hideLabel">
      {{copyLabel}}
    </div>
    <a v-for="item in filter.list" :href="'#' + item.value" class="a-btn a-btn--border btn-filter filter-list__btn" v-bind:class="{ 'is-active': isSelected(item.value) }" @click.prevent="click(item)">
      <i v-show="item.active && filter.togglable" class="icon icon-times"></i>
      {{ item.label }}
    </a>
  </div>
</template>

<script>
  export default {
    props: {
      filter: {
        type: Object,
        required: true
      },
      selected: {
        type: String,
        required: true
      }
    },
    computed: {
      copyLabel: function () {
        return this.$store.getters.copy(this.filter.label)
      }
    },
    methods: {
      isSelected: function (value) {
        return value === this.selected
      },
      click: function (item) {
        let value = item.value

        if (this.filter.togglable) {
          if (typeof (item.active) === 'undefined') item.active = false
          this.onlyOneActive(item.value)
          item.active = !item.active
          value = item.active ? item.value : this.filter.default
        }

        this.$store.dispatch('setFilter', {
          key: this.filter.key,
          value: value
        })
      },
      onlyOneActive: function (value) {
        this.filter.list.forEach(el => {
          if (el.value !== value) el.active = false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/filter/FilterButton.vue